import { render, staticRenderFns } from "./OpenAiTab.vue?vue&type=template&id=6fdb2cfc&scoped=true"
import script from "./OpenAiTab.vue?vue&type=script&lang=js"
export * from "./OpenAiTab.vue?vue&type=script&lang=js"
import style0 from "./OpenAiTab.vue?vue&type=style&index=0&id=6fdb2cfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fdb2cfc",
  null
  
)

export default component.exports